import { Fragment, type ReactNode } from "react";

/**
 * Render a translated line where `**...**` marks emphasis, turning those
 * segments into a darker, semibold <strong>. Keeps markup out of the i18n
 * JSON (translators only see `**word**`) and is shared by the support home
 * and chat tabs so the pinned notice styles identically in both.
 */
export function renderEmphasis(text: string): ReactNode[] {
  return text.split(/\*\*(.+?)\*\*/g).map((segment, idx) =>
    idx % 2 === 1 ? (
      <strong key={idx} className="font-semibold text-red-900">
        {segment}
      </strong>
    ) : (
      <Fragment key={idx}>{segment}</Fragment>
    ),
  );
}
